import { z } from "zod";
export const PlaybackProgressSchema = z.object({
    chapter: z.number().int().positive(),
    percent: z.number().min(0).max(100),
});
